import React from "react";
import { Alert, Row } from "antd";
import { useQuery } from "@apollo/client";
// import { useTranslation } from "react-i18next";

// graphql
import GET_COURSE_DETAILS from "graphql/queries/GetCourseDetails";

// custom components
import ClassList from "common/class_card/ClassList";

// styling
import * as Layout from "common/layout";
import { CourseDetails, FollowingCourse } from "./CourseClassStyle";

const { PageSection } = Layout;

type CourseClassesProps = {
  currentCourseId: number;
  courseDescription?: string;
  isHighestLevel: boolean;
  setCourseFromLocationId: (id: number) => void;
};

const CourseClasses = ({
  currentCourseId,
  courseDescription,
  isHighestLevel,
  setCourseFromLocationId,
}: CourseClassesProps) => {
  // const { t } = useTranslation("book_a_course");

  const {
    data: courseData,
    loading,
    error,
  } = useQuery(GET_COURSE_DETAILS, {
    skip: !currentCourseId,
    variables: {
      id: currentCourseId,
    },
    fetchPolicy: "network-only",
  });

  const navigateToCourse = () => {
    setCourseFromLocationId(Number(currentCourseId) + +1);
  };

  if (error) {
    return (
      <Alert
        type="error"
        message="Error loading classes. Please check your internet or let us know if this keeps happening."
      />
    );
  }

  if (loading) {
    return (
      <div style={{ height: "600px" }}>
        <Alert type="info" message="Loading..." />
      </div>
    );
  }
  return (
    <PageSection style={{ padding: "0 0%" }}>
      {currentCourseId && (
        <CourseDetails>
          <span className="detail">Course No. {currentCourseId}</span>
          <span className="detail">
            Level: {courseData?.courseDetails.lessons[0]?.level.title}
          </span>
          <span className="detail">Course Name: {courseDescription} </span>
          {!isHighestLevel && (
            <FollowingCourse type="button" onClick={navigateToCourse}>
              Follow on Course:{" "}
              <span style={{ textDecoration: "underline", color: "#1070b6" }}>
                {Number(currentCourseId) + +1}
              </span>
            </FollowingCourse>
          )}
        </CourseDetails>
      )}
      <Row gutter={24}>
        <ClassList
          lessons={courseData?.courseDetails.lessons}
          allowsBooking
          showRibbon={{ completed: true, rated: true, past: true }}
          nextCourseId={
            !isHighestLevel ? Number(currentCourseId) + +1 : undefined
          }
          setCourseFromLocationId={
            !isHighestLevel ? setCourseFromLocationId : undefined
          }
        />
      </Row>
    </PageSection>
  );
};

export default CourseClasses;
